import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import { addIcon, nextIcon } from '../../../assets/images';
import { polyglot } from '../../../assets/locales';
import Improvement from './Improvement';
import ROUTES from '../../../constants/RouteConstants';

class Step1 extends Component {
  //adds new improvement to end of array.
  appendImprovement = () => {
    this.props.appendImprovement();
  };

  //updates continueClicked field in redux store.
  submitStep1 = () => {
    this.props.submitStep1(true);
  };

  /*
   * Checks for errors on all <Improvement /> child components once continue button is clicked.
   * If no errors are found, page 2 will be loaded.
   *
   */
  componentDidUpdate(prevProps) {
    if (this.props.continueClicked !== prevProps.continueClicked) {
      const { improvements, navigate, goToStep2, submitStep1 } = this.props;
      const { continueClicked } = this.props;
      const errors = improvements.filter(({ errors }) => {
        return !!errors.title || !!errors.cost || !!errors.units || !!errors.submit;
      });
      submitStep1(false); //reset continueClicked to false
      if (errors.length === 0 && continueClicked === false) {
        goToStep2();
        navigate(ROUTES.EXPLORER_STEP2);
      }
    }
  }

  render() {
    const { improvements, continueClicked, updateImprovement, deleteImprovement } = this.props;
    return (
      <div className="step1">
        <>
          <div className="step1-title">{polyglot.t('header.bodyHeader')}</div>
          <div className="step1-disclaimer">{polyglot.t('header.disclaimer')}</div>
          <div className="step1-title-subtext">{polyglot.t('step1.subText')}</div>
          {/*  prettier-ignore*/}
          <div className="step1-description">
           <span dangerouslySetInnerHTML={{ __html: polyglot.t('step1.descriptionHTML')}}></span>
          </div>
        </>

        {improvements.map((improvement, index) => (
          <Improvement
            key={improvement.id}
            index={index}
            id={improvement.id}
            length={improvements.length}
            improvement={improvement}
            deleteImprovement={deleteImprovement}
            updateImprovement={updateImprovement}
            continueClicked={continueClicked}
          />
        ))}

        <div className="step1-add" onClick={this.appendImprovement}>
          <img className="step1-add-icon" src={addIcon} alt="" />
          <span className="step1-add-text">{polyglot.t('step1.addImprovement')}</span>
        </div>
        <Button variant="primary" className="step1-continue-btn" onClick={this.submitStep1}>
          <img className="step1-continue-btn-icon" src={nextIcon} alt="" /> Continue
        </Button>
      </div>
    );
  }
}
export default Step1;